import {l} from "types/typescriptdefinisjoner_lederplan";
import {Konfigurasjon} from "felles/infrastruktur/Konfigurasjon";
import _ from 'lodash'

export function avatarUrlFilterForInjisering() {
    return [Konfigurasjon.regNavn, avatarUrlFilter];
}

export function avatarUrlFilter(konfigurasjon: Konfigurasjon): Function {
    return function (bruker: l.EnkelBrukerModell) {
        if (_.isUndefined(bruker) || _.isNull(bruker))
            return '';
        return konfigurasjon.serviceRotUrl + "/api/bruker/" + bruker.id + "/avatar/" + bruker.avatarId + ".jpg";
    };
}

